import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Skeleton from "@mui/material/Skeleton";
import "./ProductList.css";

function ProductList() {
  const [products, setProducts] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [search, setSearch] = useState("");
 const [category, setCategory] = useState("All"); // selected category
const [categories, setCategories] = useState(["All"]); // list of categories
const [loading, setLoading] = useState(true);

// fetch categories from API
useEffect(() => {
  fetch("https://citrine-backend-0hws.onrender.com/api/categories")
    .then(res => res.json())
    .then(data => {
      // make sure all items are strings
      const categoryStrings = data.map(c => c == null ? "" : String(c));
      setCategories(["All", ...categoryStrings]);
      console.log("Categories loaded:", categoryStrings);
    })
    .catch(err => console.error(err));
}, []);
  const navigate = useNavigate();

  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const showToast = (message, severity = "success") => {
    setToast({ open: true, message, severity });
  };

  // 🔹 Fetch products
  useEffect(() => {
  setLoading(true);

  fetch("https://citrine-backend-0hws.onrender.com/api/products")
    .then((res) => res.json())
    .then((data) => {
      setProducts(data);
    })
    .catch((err) => console.error(err))
    .finally(() => setLoading(false)); // ✅ important
}, []);
  // useEffect(() => {
  //   fetch("https://citrine-backend-0hws.onrender.com/api/products")
  //   .then((res) => res.json())
  //     .then((data) => setProducts(data))
  //     .catch((err) => console.error(err));
  // }, []);

  // 🔹 Fetch cart
  const fetchCart = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await fetch("https://citrine-backend-0hws.onrender.com/api/cart", {
        headers: { Authorization: token }
      });

      const data = await res.json();
      setCartItems(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  // useEffect(() => {
  //   const handleUpdate = () => fetchCart();
  //   window.addEventListener("cartUpdated", handleUpdate);
  //   return () => window.removeEventListener("cartUpdated", handleUpdate);
  // }, []);

useEffect(() => {
  const handleUpdate = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await fetch("https://citrine-backend-0hws.onrender.com/api/cart", {
        headers: { Authorization: token },
      });
      const serverCart = await res.json();

      // merge without removing items added optimistically
      setCartItems((prev) => {
        const existingIds = new Set(prev.map((i) => i.product_id));
        const merged = [...prev];
        serverCart.forEach((item) => {
          if (!existingIds.has(item.product_id)) merged.push(item);
        });
        return merged;
      });
    } catch (err) {
      console.error(err);
    }
  };

  window.addEventListener("cartUpdated", handleUpdate);
  return () => window.removeEventListener("cartUpdated", handleUpdate);
}, []);


  // add to cart
  // 🔹 Add to cart
const addToCart = async (product_id) => {
  const token = localStorage.getItem("token");

  if (!token) {
    showToast("Please login first", "warning");
    setTimeout(() => navigate("/login"), 1000);
    return;
  }

  const alreadyExists = cartItems.some(
    (item) => Number(item.product_id) === Number(product_id)
  );

  if (alreadyExists) {
    showToast("Already in cart", "info");
    setTimeout(() => navigate("/cart"), 1000);
    return;
  }
  try {
    // 1️⃣ Optimistic update
    setCartItems((prev) => [...prev, { product_id }]);
    showToast("Added to cart 🛒", "success");

    // 2️⃣ Call API (no fetchCart)
    await fetch("https://citrine-backend-0hws.onrender.com/api/cart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ product_id }),
    });

    // 3️⃣ Dispatch cartUpdated for other components (they can merge safely)
    window.dispatchEvent(new Event("cartUpdated"));
  } catch (err) {
    console.error(err);
    showToast("Error adding product", "error");

    // Rollback
    setCartItems((prev) =>
      prev.filter((item) => Number(item.product_id) !== Number(product_id))
    );
  }
};


  // 🔹 Add to cart
  // const addToCart = async (product_id) => {
  //   const token = localStorage.getItem("token");

  //   if (!token) {
  //     showToast("Please login first", "warning");
  //     setTimeout(() => navigate("/login"), 1000);
  //     return;
  //   }

  //   const alreadyExists = cartItems.some(
  //     (item) => Number(item.product_id) === Number(product_id)
  //   );

  //   if (alreadyExists) {
  //     showToast("Already in cart", "info");
  //     setTimeout(() => navigate("/cart"), 1000);
  //     return;
  //   }

  //   try {
  //     await fetch("https://citrine-backend-0hws.onrender.com/api/cart", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: token
  //       },
  //       body: JSON.stringify({ product_id })
  //     });

  //     fetchCart();
  //     showToast("Added to cart 🛒", "success");

  //     window.dispatchEvent(new Event("cartUpdated"));
  //   } catch (err) {
  //     console.error(err);
  //     showToast("Error adding product", "error");
  //   }
  // };

  // 🔹 Check cart
  const isInCart = (product_id) => {
    return cartItems.some(
      (item) => Number(item.product_id) === Number(product_id)
    );
  };

  // 🔥 Filter logic
  // const filteredProducts = products.filter((p) => {
  //   const matchSearch =
  //     p.product_name.toLowerCase().includes(search.toLowerCase()) ||
  //     (p.category || "").toLowerCase().includes(search.toLowerCase());

  //   const matchCategory =
  //     category === "All" || p.category === category;

  //   return matchSearch && matchCategory;
  // });
  const filteredProducts = products.filter((p) => {
  const matchSearch =
    (p.product_name || "").toLowerCase().includes(search.toLowerCase()) ||
    (p.category || "").toLowerCase().includes(search.toLowerCase());

  const matchCategory =
    category === "All" ||
    (p.category || "").toLowerCase() === category.toLowerCase();

  return matchSearch && matchCategory;
});

const productsByCategory = filteredProducts.reduce((acc, product) => {
  const cat = product.category || "Uncategorized";
  if (!acc[cat]) acc[cat] = [];
  acc[cat].push(product);
  return acc;
}, {});

  return (
    <div style={styles.container}>
      <br /><br /><br />

      <div style={styles.topBar}>
        <input
          type="text"
          placeholder="Search product..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={styles.search}
        />

        <select
  value={category}
  onChange={(e) => setCategory(e.target.value)}
  style={styles.select}
>
  {categories.map((c, i) => (
    <option key={i} value={c}>
      {c}
    </option>
  ))}
</select>
      </div>

      {/* 🛍 Products */}
     {/* {loading ? (
<div className="product-grid">
    {Array.from(new Array(6)).map((_, index) => (
      <div key={index} className="product-card">
        <Skeleton variant="rectangular" height={150} animation="wave" />
        <Skeleton variant="text" height={30} style={{ marginTop: 10 }} />
        <Skeleton variant="text" height={20} width="60%" />
        <Skeleton variant="text" height={25} width="40%" />
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
          <Skeleton variant="rectangular" height={35} width="45%" />
          <Skeleton variant="rectangular" height={35} width="45%" />
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="product-grid">
    {filteredProducts.map((p) => {
      const inCart = isInCart(p.product_id);

      return (
        <div key={p.product_id} className="product-card">
          <img
            src={p.product_image}
            alt=""
            style={styles.image}
          />
          <h3>{p.product_name}</h3>
          <p style={styles.category}>{p.category}</p>
          <p style={styles.price}>₹ {p.product_price}</p>

          <div style={styles.buttonGroup}>
            <button
              onClick={() => navigate(`/product/${p.product_id}`)}
              style={{ ...styles.button, backgroundColor: "#6c757d" }}
            >
              View
            </button>

            <button
              onClick={() =>
                inCart ? navigate("/cart") : addToCart(p.product_id)
              }
              style={{
                ...styles.button,
                backgroundColor: inCart ? "#28a745" : "#007bff"
              }}
            >
              {inCart ? "Show Cart" : "Add to Cart"}
            </button>
          </div>
        </div>
      );
    })}
  </div>
)} */}


<div>
  {loading ? (
    <div className="product-grid">
      {Array.from(new Array(6)).map((_, index) => (
        <div key={index} className="product-card">
          <Skeleton variant="rectangular" height={150} animation="wave" />
          <Skeleton variant="text" height={30} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} width="60%" />
          <Skeleton variant="text" height={25} width="40%" />
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
            <Skeleton variant="rectangular" height={35} width="45%" />
            <Skeleton variant="rectangular" height={35} width="45%" />
          </div>
        </div>
      ))}
    </div>
  ) : (
    Object.keys(productsByCategory).map((cat) => (
      <div key={cat} style={{ marginBottom: "40px", textAlign: "left" }}>
        <h2 style={{ marginBottom: "20px", color: "#333" }}>{cat}</h2>
        <div className="product-grid">
          {productsByCategory[cat].map((p) => {
            const inCart = isInCart(p.product_id);

            return (
              <div key={p.product_id} className="product-card">
                <img src={p.product_image} alt="" style={styles.image} />
                <h3>{p.product_name}</h3>
                <p style={styles.category}>{p.category}</p>
                <p style={styles.price}>₹ {p.product_price}</p>

                <div style={styles.buttonGroup}>
                  <button
                    onClick={() => navigate(`/product/${p.product_id}`)}
                    style={{ ...styles.button, backgroundColor: "#6c757d" }}
                  >
                    View
                  </button>

                  <button
                    onClick={() =>
                      inCart ? navigate("/cart") : addToCart(p.product_id)
                    }
                    style={{
                      ...styles.button,
                      backgroundColor: inCart ? "#28a745" : "#007bff",
                    }}
                  >
                    {inCart ? "Show Cart" : "Add to Cart"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    ))
  )}
</div>

      {/* 🔔 Toast */}
      <Snackbar
        open={toast.open}
        autoHideDuration={2000}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={toast.severity} variant="filled">
          {toast.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
// 🎨 Styles
// 🎨 Styles
const styles = {
  buttonGroup: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    marginTop: "10px"
  },
  topBar: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "20px",
    flexWrap: "wrap"
  },
  search: {
    padding: "10px",
    width: "250px",
    borderRadius: "8px",
    border: "1px solid #ccc"
  },
  select: {
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc"
  },
  category: {
    color: "#777",
    fontSize: "14px"
  },
  container: {
    padding: "20px",
    textAlign: "center",
    backgroundColor: "#f5f5f5"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: "20px",
    marginBottom: "50px"
  },
  card: {
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    transition: "0.3s"
  },
  image: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
    borderRadius: "8px",
    marginBottom: "10px"
  },
  name: {
    marginBottom: "10px"
  },
  price: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "15px"
  },
  button: {
    padding: "10px 15px",
    border: "none",
    borderRadius: "8px",
    color: "#fff",
    cursor: "pointer"
  },

  // Mobile responsiveness
  '@media (max-width: 768px)': {
    grid: {
      gridTemplateColumns: "repeat(2, 1fr)", // 2 items per row
      gap: "15px"
    },
    topBar: {
      flexDirection: "column",
      alignItems: "center"
    },
    search: {
      width: "90%"
    },
    select: {
      width: "90%"
    }
  },

  '@media (max-width: 480px)': {
    grid: {
      gridTemplateColumns: "1fr", // 1 item per row on very small screens
      gap: "15px"
    }
  }
};



export default ProductList;